export const ORDER_SUMMARY_TABS = {
  ACTIVE: 'orderSummaryActive',
  PAST_EVENTS: 'orderSummaryPastEvents'
};
